var map = {
	"./partner-01.svg": 79873,
	"./partner-02.svg": 86738,
	"./partner-03.svg": 1379,
	"./partner-04.svg": 31196,
	"./partner-05.svg": 20669,
	"./partner-10.svg": 54291,
	"./partner-11.svg": 49122,
	"./partner-12.svg": 69489,
	"./partner-7.svg": 31135,
	"./partner-8.svg": 5867,
	"./partner-9.svg": 3753,
	"./partner1.svg": 39972,
	"./partner2.svg": 44567,
	"./partner3.svg": 81766,
	"./partner4.svg": 8649,
	"./partner5.svg": 49496,
	"./partner6.svg": 88331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60785;